import { z } from 'zod';
/** How the ground-truth label was produced (see WAFER_ID_SAGEMAKER_TRAINING_AND_INFERENCE_PLAN.md §5.2). */
export const waferIdTrainingLabelSourceSchema = z.enum([
    'human_confirm',
    'human_correct',
    'import',
    'inference_auto',
]);
/**
 * One labeled wafer fingerprint image for TrOCR fine-tune.
 *
 * `image_key` is always the canonical S3 object key (insight bucket or dataset prefix).
 * `image_local_path` is optional input-only for publish-dataset (stripped after upload).
 */
export const waferIdTrainingManifestRowSchema = z.object({
    image_key: z.string().min(1),
    ground_truth: z.string().min(1),
    source: waferIdTrainingLabelSourceSchema,
    tenant_id: z.string().uuid(),
    captured_at: z.string().datetime({ offset: true }).or(z.string().datetime()),
    slot_number: z.number().int().positive().optional(),
    lighting_mode: z.string().min(1).optional(),
    job_id: z.string().optional(),
    /** Relative path under --local-root when publishing from disk (not stored in S3 manifest). */
    image_local_path: z.string().min(1).optional(),
});
/** Published dataset manifest (immutable version in S3). */
export const waferIdTrainingDatasetManifestSchema = z.object({
    dataset_version: z.string().min(1),
    tenant_id: z.string().uuid(),
    published_at: z.string().datetime({ offset: true }).or(z.string().datetime()),
    row_count: z.number().int().positive(),
    rows: z.array(waferIdTrainingManifestRowSchema.omit({ image_local_path: true })),
});
/** S3 prefix: wafer-id/datasets/{tenantId}/{datasetVersion}/ */
export function waferIdTrainingDatasetS3Prefix(tenantId, datasetVersion) {
    return `wafer-id/datasets/${tenantId}/${datasetVersion}`;
}
export function waferIdTrainingDatasetManifestS3Key(tenantId, datasetVersion) {
    return `${waferIdTrainingDatasetS3Prefix(tenantId, datasetVersion)}/manifest.json`;
}
//# sourceMappingURL=wafer-id-training-manifest.schema.js.map